"use client";

export default function TableItem({
  user,
  handleShow,
  handleDelete,
  onQuickActivate,
}) {
  function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);
    var interval = seconds / 31536000;
    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  }

  const getUserTypeBadge = (userType) => {
    const typeClasses = {
      Admin: "badge bg-primary",
      Influencer: "badge bg-info",
      Business: "badge bg-success",
      User: "badge bg-secondary",
    };
    return typeClasses[userType] || "badge bg-secondary";
  };

  const getApprovalBadge = (state) => {
    if (state === 0) {
      return "badge bg-warning";
    } else {
      return "badge bg-success";
    }
  };

  const getApprovalText = (state) => {
    if (state === 0) {
      return "Not Approved";
    } else {
      return "Approved";
    }
  };

  const handleQuickActivate = async (e) => {
    e.stopPropagation();
    if (onQuickActivate) {
      await onQuickActivate(user.id);
    }
  };

  return (
    <>
      <style jsx>{`
        .social-media-link {
          transition: all 0.3s ease;
          padding: 4px 8px;
          border-radius: 6px;
          border: 1px solid transparent;
        }

        .social-media-link:hover {
          background-color: rgba(0, 0, 0, 0.05);
          transform: translateY(-1px);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .social-media-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          transition: all 0.3s ease;
        }

        .instagram-icon {
          background: linear-gradient(
            45deg,
            #f09433 0%,
            #e6683c 25%,
            #dc2743 50%,
            #cc2366 75%,
            #bc1888 100%
          );
          color: white;
        }

        .facebook-icon {
          background: #1877f2;
          color: white;
        }

        .social-media-text {
          font-size: 12px;
          font-weight: 500;
          color: #495057;
        }

        .social-media-link:hover .social-media-icon {
          transform: scale(1.1);
        }

        .social-media-link:hover .social-media-text {
          color: #212529;
        }
      `}</style>
      <tr key={user.id}>
        <td className="id" style={{ display: "none" }}>
          {user.id}
        </td>
        <td className="user_id">{user.id}</td>
        <td className="user_name">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-3">
              <div className="avatar-xs">
                <div className="avatar-title rounded-circle bg-light text-primary fs-16">
                  {user.name.charAt(0).toUpperCase()}
                </div>
              </div>
            </div>
            <div className="flex-grow-1">
              <h6 className="fs-14 mb-1">{user.name}</h6>
              <p className="text-muted mb-0">{user.email}</p>
            </div>
          </div>
        </td>
        <td className="user_type">
          <span className={getUserTypeBadge(user.user_type)}>
            {user.user_type}
          </span>
        </td>
        <td className="user_status">
          <span className={getApprovalBadge(user.state)}>
            {getApprovalText(user.state)}
          </span>
        </td>
        <td className="phone">{user.phone || "N/A"}</td>
        <td className="social_media">
          {user.profile?.social_media ? (
            <div className="d-flex flex-column gap-2">
              {user.profile.social_media.instagram && (
                <a
                  href={user.profile.social_media.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center text-decoration-none social-media-link"
                  title="View Instagram Profile"
                >
                  <div className="social-media-icon instagram-icon me-2">
                    <i className="ri-instagram-line"></i>
                  </div>
                  <span className="social-media-text">Instagram</span>
                </a>
              )}
              {user.profile.social_media.facebook && (
                <a
                  href={user.profile.social_media.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center text-decoration-none social-media-link"
                  title="View Facebook Profile"
                >
                  <div className="social-media-icon facebook-icon me-2">
                    <i className="ri-facebook-circle-line"></i>
                  </div>
                  <span className="social-media-text">Facebook</span>
                </a>
              )}
              {!user.profile?.social_media?.instagram &&
                !user.profile?.social_media?.facebook && (
                  <span className="text-muted fst-italic">
                    <i className="ri-link me-1"></i>
                    No social media
                  </span>
                )}
            </div>
          ) : (
            <span className="text-muted fst-italic">
              <i className="ri-link me-1"></i>
              No social media
            </span>
          )}
        </td>
        <td className="date">{timeSince(new Date(user.created_at))}</td>
        <td>
          <div className="d-flex gap-2">
            {/* Quick Approve Button - Only show for not approved users */}
            {user.state === 0 && user.user_type !== "Admin" && (
              <div className="activate">
                <button
                  className="btn btn-sm btn-success"
                  onClick={handleQuickActivate}
                  title="Quick Approve User"
                >
                  <i className="ri-check-double-line align-bottom"></i>
                </button>
              </div>
            )}

            <div className="show">
              <button
                className="btn btn-sm btn-info show-item-btn"
                data-bs-toggle="modal"
                data-bs-target="#showModal"
                onClick={() => handleShow(user)}
                title="View Details"
              >
                <i className="ri-eye-line align-bottom"></i>
              </button>
            </div>

            {user.user_type !== "Admin" && (
              <div className="remove">
                <button
                  className="btn btn-sm btn-danger remove-item-btn"
                  onClick={() => handleDelete(user.id)}
                  title="Delete User"
                >
                  <i className="ri-delete-bin-6-line align-bottom"></i>
                </button>
              </div>
            )}
          </div>
        </td>
      </tr>
    </>
  );
}
